import { ApiViewerToolbar } from '~/portal/components/ApiViewerToolbar'
import { SyntaxRenderer } from '~/portal/components/SyntaxRenderer'
import { API_FILE_TYPES } from '~/portal/types/downloadApi'
import { CONTENT_TYPE } from '~/shared/types/content'

const graphqlDownloadOptions = [{ id: '1', name: API_FILE_TYPES.GRAPHQL }]

export const GraphQlViewer = ({
  tableOfContentsId,
  title,
  registryUrl,
  content,
  lastModifiedDate,
  providerContentSlug,
  showEditButtons,
  accentColor,
  fontName,
  isConsumerSide = true,
  downloadDisabled,
}: {
  tableOfContentsId?: string
  title?: string
  registryUrl?: string
  content?: object
  lastModifiedDate?: string
  providerContentSlug?: string
  showEditButtons?: boolean
  accentColor?: string
  fontName?: string
  isConsumerSide?: boolean
  downloadDisabled?: boolean
}) => {
  const buildDownloadUrl = registryUrl
    ? () => `/services/api/graphql-download?url=${encodeURIComponent(registryUrl)}&filename=${encodeURIComponent(title ?? 'api')}`
    : undefined

  return (
    <div
      data-testid="graphql-markdown-container"
      id="top"
      className="flex flex-col"
      style={{ fontFamily: fontName }}
    >
      <ApiViewerToolbar
        testId="graphql-viewer-toolbar"
        downloadOptions={graphqlDownloadOptions}
        buildDownloadUrl={buildDownloadUrl}
        optionLabelBuilder={() => API_FILE_TYPES.GRAPHQL}
        providerContentSlug={providerContentSlug}
        showEditButtons={showEditButtons}
        accentColor={accentColor}
        downloadDisabled={downloadDisabled}
      />
      <div className="relative">
        <SyntaxRenderer
          key={tableOfContentsId}
          type={CONTENT_TYPE.GRAPHQL}
          content={content}
          title={title}
          lastModifiedDate={lastModifiedDate}
          providerContentSlug={providerContentSlug}
          isConsumerSide={isConsumerSide}
          useMarkdocRenderer={true}
        />
      </div>
    </div>
  )
}
